import { useFormikContext } from 'formik';

import { BoxSelector } from '@@/BoxSelector';
import { FormSection } from '@@/form-components/FormSection';
import {
  git,
  helmRepository,
} from '@@/BoxSelector/common-options/build-methods';

import { FormValues } from '../types';

import { HelmGitForm } from './HelmGitForm';
import { HelmRepositoryForm } from './HelmRepositoryForm';

const buildMethods = [git, helmRepository] as const;

interface Props {
  webhookId: string;
}

export function HelmChartForm({ webhookId }: Props) {
  const { values, setValues } = useFormikContext<FormValues>();
  const { method } = values;

  function handleChange(newValues: Partial<FormValues>) {
    setValues((values) => ({
      ...values,
      ...newValues,
    }));
  }

  return (
    <>
      <FormSection title="Build Method">
        <BoxSelector
          options={buildMethods}
          onChange={(value) => handleChange({ method: value })}
          value={method}
          radioName="method"
          slim
        />
      </FormSection>

      {method === git.value && <HelmGitForm webhookId={webhookId} />}

      {method === helmRepository.value && <HelmRepositoryForm />}
    </>
  );
}
